import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';

import Icon from '@material-ui/core/Icon';
import { CommonStyles } from '../../styles/Styles';
import { keys } from '@material-ui/core/styles/createBreakpoints';
import { ImageComponent } from '../../components/quizzing/ImageComponent';

export class CheckBoxComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    },
    this.ids = []
  }

  handleCheckbox = name => event => {
    // this.setState({ ...this.state, [name]: event.target.checked });
    const index = this.ids.indexOf(name)
    if (index !== -1) {
      this.ids.splice(index, 1);
      this.props.handleState(this.props.data.id, this.ids)
    } else {
      this.ids.push(name)
      this.props.handleState(this.props.data.id, this.ids)
    }
  }

  render() {
    const thisObj = this //TODO
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          {this.props.mainTitle &&
            <div className={css(CommonStyles.questionMainTitleContainer)}>
              <p className={css(CommonStyles.questionMainTitle)}>{this.props.mainTitle}</p>
              {this.props.showInformationPopup &&
                <div className={css(CommonStyles.questionDetailContainer)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                  <p className={css(CommonStyles.questionDetailContent)}>i</p>
                </div>
              }
            </div>
          }
          {this.props.data.subTitle &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
        </div>
        {this.props.data.image &&
          <div className={css(CommonStyles.outerImageContainer)}>
            <ImageComponent data={this.props.data} />
          </div>
        }
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <Grid container spacing={3} className={css(Styles.outerMainContainer)}>
            {Object.keys(this.props.data.options).sort(function (a, b) { return (Number(thisObj.props.data.options[a].order) - Number(thisObj.props.data.options[b].order)) })
              .map(item => {
                return (
                  <Grid item xs={12} sm={12} md={6} lg={6} className={css(Styles.outerContainer)} key={item}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state[this.props.data.options[item].id]}
                          onChange={this.handleCheckbox(this.props.data.options[item].id)}
                          value={this.props.data.options[item].id}
                          color='primary'
                          checkedIcon={
                            <div className={css(Styles.icon)}>
                              <Icon className={css(Styles.checkedIcon)}>done</Icon>
                            </div>
                          }
                          icon={
                            <div className={css(Styles.icon)} />
                          }
                          className={css(CommonStyles.controlLabel)}
                        />
                      }
                      label={this.props.data.options[item].title}
                      classes={{
                        label: css(CommonStyles.formLabel, Styles.customPadding)
                      }}
                      className={css(CommonStyles.innerSelection)}
                    />
                  </Grid>
                )
              })}
          </Grid>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerMainContainer: {
    width: '100%',
    '@media (max-width: 767px)': {
      margin: 0,
    }
  },
  outerContainer: {
    '@media (max-width: 767px)': {
      padding: 5,
    }
  },
  icon: {
    width: 30,
    height: 30,
    background: AppTheme.secondaryBg + '0% 0% no-repeat padding-box',
    border: '3px solid' + AppTheme.borderColor,
    borderRadius: 10,
    zIndex: 0,
    '@media (max-width: 767px)': {
      width: 25,
      height: 25,
    }
  },
  checkedIcon: {
    fontSize: 34,
    fontWeight: 'bold',
    color: AppTheme.selectedColor,
    zIndex: 1,
    lineHeight: .7,
    '@media (max-width: 767px)': {
      fontSize: 29,
    }
  },
  innerContainer: {
    marginTop: 10,
    marginLeft: 20,
    '@media (max-width: 767px)': {
      marginLeft: 10,
    }
  },
  customPadding: {
    paddingTop: 10,
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/CheckBoxComponent.js